<template>
	<div>
		<header class="lang-header">
			<div class="logo-section">
        <div class="img-block d-flex align-items-center">
          <img src="images/main_logo.png">
        </div>
        <div class="subtitle">
          {{ t("Secure digital insurance process") }}
        </div>
      </div>
      <div class="header-right-section">
        <div class="user-block">
          <div v-if="user?.name" class="user-name">
            {{ user.name }}
          </div>
          <button class="btn btn-link btn-no" @click="reDirectToiSavta"> {{t("Logout and go Back to iSavta")}} </button>
        </div>
        <div class="lang-switch">
          <select v-model="locale" @change="changeLocale">
            <option value="he">עברית</option>
            <option value="en">English</option>
          </select>
        </div>
        <div class="logo-rigth-section">
          <div class="img-block d-flex align-items-center">
            <img src="images/page_logo.jpg"> 
          </div>
        </div>
      </div>
		</header>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { logoutAndRedirect } from '@/services/auth';
defineOptions({
	name: 'AppHeader'
})
const { locale, t } = useI18n();
const store = useStore();
const changeLocale = (e) => {
  store.dispatch('setLocale', e.target.value)
}
// const appTitle = process.env.VUE_APP_TITLE || 'Misgav';
const user = computed(() => store.getters.getAuth);
const reDirectToiSavta = () => {
  return logoutAndRedirect();
}
</script>

<style>
.lang-header{
	display: flex;
	justify-content: space-between;
	padding: 12px 20px;
}
.lang-switch {
	display: flex;
	background: #f1f5f9;
	border-radius: 10px;
	padding: 4px;
}

.lang-switch select {
	border: none;
	background: transparent;
	padding: 6px 14px;
	cursor: pointer;
	color: #475569;
	transition: all 0.2s ease;
}
.logo-section,
.logo-rigth-section {
    display: flex;
    align-items: center;
}
.logo-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}
.img-block img {
    height: 40px;
    width: auto;
    object-fit: contain;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.subtitle {
  font-size: 13px;
  color: #6b7280;
  
}

.user-name {
  margin-top: 6px;
  font-size: 13px;
  color: #374151;
  background: #f3f4f6;
  padding: 4px 10px;
  border-radius: 999px;
  width: fit-content;
}
.header-right-section {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>